module.exports = {"440883001":"梅录街道","440883002":"塘尾街道","440883003":"大山江街道","440883004":"博铺街道","440883005":"海滨街道","440883100":"浅水镇","440883101":"长岐镇","440883102":"覃巴镇","440883103":"王村港镇","440883104":"振文镇","440883105":"樟铺镇","440883106":"吴阳镇","440883107":"塘缀镇","440883109":"黄坡镇","440883111":"兰石镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440883.json
// module id = 1831
// module chunks = 0